






























































































import Vue from 'vue';
import VueCompositionAPI, {
  ref,
  computed,
  defineComponent,
} from '@vue/composition-api';

import ReporterIs from '@/components/reporter-is.vue';
import WaitTimeReport from '@/components/wait-time-report.vue';
import BedsReport from '@/components/beds-report.vue';
import VentReport from '@/components/vent-report.vue';
import AdditionalCommentsReport from '@/components/additional-comments-report.vue';

import { useRouter, RouterAliases } from '../router';
import {
  getRouterParams,
  getReporter,
  saveReporter,
  getWaitTime,
  saveWaitTime,
  getCovidBedsReport,
  getICUBedsReport,
  saveCovidBedsReport,
  saveICUBedsReport,
  getTotalVentilatorsReport,
  getAvailableVentilatorsReport,
  saveTotalVentilatorsReport,
  saveAvailableVentilatorsReport,
  getAdditionalComments,
  saveAdditionalComments,
} from '../store';
import { ConfidentValue } from '../store/types';

Vue.use(VueCompositionAPI);

interface AgeAndGender {
  age: string;
  gender: string;
}

const AsmtWizardComponent = defineComponent({
  components: {
    ReporterIs,
    WaitTimeReport,
    BedsReport,
    VentReport,
    AdditionalCommentsReport,
  },
  setup() {
    const router = useRouter();
    const NUMBER_OF_STEPS = 5;

    const stepNumber = computed<string>(() => {
      const params = getRouterParams();
      /* eslint-disable */
      // @ts-ignore
      window.gtag &&
        // @ts-ignore
        gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID, {
          page_path: `report-wizard/step=${params.step}/hospitalId=${params.hospitalId}`,
          app_name: 'Patients Care',
        });
      /* eslint-enable */

      return params.step || '1';
    });
    const stepCount = ref(NUMBER_OF_STEPS);
    const back = () => {
      window.history.back();
    };

    const reporter = computed(() => {
      return getReporter();
    });
    const updateReporter = async (value: number) => {
      return saveReporter(value);
    };

    const waitTime = computed(() => {
      return getWaitTime();
    });
    const updateWaitTime = (value: ConfidentValue) => {
      saveWaitTime(value);
    };
    const isTimeReportActive = computed(() => {
      return stepNumber.value === '2';
    });

    const covidReportState = computed(() => {
      return getCovidBedsReport();
    });
    const icuReportState = computed(() => {
      return getICUBedsReport();
    });
    const isCovidStateInputActive = computed(() => {
      return stepNumber.value === '3';
    });
    const covidStateChanged = (value: ConfidentValue) => {
      saveCovidBedsReport(value);
    };
    const icuStateChanged = (value: ConfidentValue) => {
      saveICUBedsReport(value);
    };
    const totalVentsReportState = computed(() => {
      return getTotalVentilatorsReport();
    });
    const availableVentsReportState = computed(() => {
      return getAvailableVentilatorsReport();
    });
    const isVentStateInputActive = computed(() => {
      return stepNumber.value === '4';
    });
    const totalVentsStateChanged = (value: ConfidentValue) => {
      saveTotalVentilatorsReport(value);
    };
    const availableVentsStateChanged = (value: ConfidentValue) => {
      saveAvailableVentilatorsReport(value);
    };

    const additionalCommentsValue = computed(() => {
      return getAdditionalComments();
    });
    const updateAdditionalComments = async (value: string) => {
      return saveAdditionalComments(value);
    };

    const nextStep = () => {
      if (+stepNumber.value === stepCount.value) {
        return router.push({
          name: RouterAliases.REPORT_VALIDATION,
        });
      }
      router.push({
        name: RouterAliases.HOSPITAL_REPORT,
        params: {
          hospitalId: router.currentRoute.params.hospitalId,
          step: (parseInt(stepNumber.value, 10) + 1).toString(),
        },
      });
    };

    const isNext = computed(() => {
      let isInputMade = false;
      switch (stepNumber.value) {
        case '1':
          isInputMade = reporter.value >= 0;
          break;
        case '2':
          isInputMade = waitTime.value.value !== '';
          break;
        case '3':
          isInputMade =
            covidReportState.value.value !== '' ||
            icuReportState.value.value !== '';
          break;
        case '4':
          isInputMade =
            totalVentsReportState.value.value !== '' ||
            availableVentsReportState.value.value !== '';
          break;
        case '5':
          isInputMade = additionalCommentsValue.value !== '';
          break;
      }
      return isInputMade;
    });

    const btnText = computed(() => {
      return isNext.value ? 'Next' : 'Skip';
    });
    return {
      stepNumber,
      stepCount,
      back,
      updateReporter,
      reporter,
      nextStep,
      waitTime,
      updateWaitTime,
      isTimeReportActive,

      covidStateChanged,
      covidReportState,
      isCovidStateInputActive,
      icuStateChanged,
      icuReportState,

      totalVentsStateChanged,
      totalVentsReportState,
      isVentStateInputActive,
      availableVentsStateChanged,
      availableVentsReportState,

      isNext,
      btnText,

      additionalCommentsValue,
      updateAdditionalComments,
    };
  },
});

export default AsmtWizardComponent;
